// Module
var code = "<div class=\"dropdown\"> <a href=\"#\" data-bind=\"click: showHelp\"> <span data-bind=\"restext: 'ScreenReaderHelpLink'\" class=\"sr-only\"></span> <span data-bind=\"restooltip: 'OpenHelpInNewWindow', placement: 'bottom', delay: 600\" aria-hidden=\"true\" class=\"glyphicon glyphicon-question-sign help-icon\"> </span> </a> </div>";
// Exports
export default code;